import { toast } from 'sonner';

/** Довше за типове: помилку треба встигнути прочитати, а не побачити, що блимнуло. */
const ERROR_DURATION_MS = 6000;

export function toastError(title: string, detail?: string): void {
  toast.error(title, { description: detail, duration: ERROR_DURATION_MS });
}

export function toastSuccess(title: string, detail?: string): void {
  toast.success(title, { description: detail });
}
